import * as React from "react";
const SvgList220Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M2 3h3v3H2V3Zm6 2.5h10v-2H8v2Zm-3 3H2v3h3v-3ZM8 11h10V9H8v2Zm-3 3H2v3h3v-3Zm3 2.5h10v-2H8v2Z"
    })
  );
export default SvgList220Px;
